import { Button } from "@progress/kendo-react-buttons";
import Spinner from "../loader/ButtonSpinner";
import { ICON_BASE_PATH } from "@/app/utils/config";
import type { ReactNode } from "react";

interface GxViewManageButtonProps {
  label?: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  loadingLabel?: string;
}

const GxViewManageButton: React.FC<GxViewManageButtonProps> = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  loadingLabel,
}) => {
  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };
  return (
    <div className="gx-view-manage-Button">
      <Button
        onClick={handleClick}
        disabled={disabled || loading}
        className="font-extrabold!"
      >
        <span>{getButtonText()}</span>
        {loading ? (
          <Spinner />
        ) : (
          <img src={`${ICON_BASE_PATH}side_arrow.svg`} alt="tick" />
        )}
      </Button>
    </div>
  );
};

export default GxViewManageButton;
